import type { ChatMessage } from "./types";

export function formatMessageTime(
  value: Date | string | number | undefined,
): string {
  if (value == null) return "";
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
  });
}

export function createUserMessage(content: string): ChatMessage {
  return {
    id: crypto.randomUUID(),
    role: "user",
    content,
    createdAt: new Date(),
    status: "sent",
  };
}

export function createAssistantMessage(
  content: string,
  partial?: Partial<ChatMessage>,
): ChatMessage {
  const id = partial?.id || partial?.messageID || crypto.randomUUID();
  return {
    role: "assistant",
    content,
    createdAt: new Date(),
    status: "sent",
    ...partial,
    id,
  };
}
